import { adminHttpClient } from '../commons/adminHttpClient'
import EmailTemplateStatus from '../../domain/mailHistory/EmailTemplateStatus'
import { NamedItemInt } from '../../domain/common/namedItem'

export type EmailTemplateDetails = {
  templateId: string
  wrapperContent: string
  templateContent: string
  status: EmailTemplateStatus
  subject: string
  product?: NamedItemInt
}

const getEmailTemplateDetails = (templateId: string) => adminHttpClient.get(`/EmailTemplates/${templateId}`)

export default getEmailTemplateDetails
